import { API_TIMEOUT, getApiPath, getCommonHeaders, handleApiError, handleApiResponse } from "../config/api";

export const getChannelList = async () => {
  try {
    const response = await fetch(`${getApiPath.getChannelList}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "getChannelList API");
  }
};

export const getSourceListBasedOnChannelId = async (channel_ids:number) => {
  try {
    const response = await fetch(`${getApiPath.getChannelSourceList}/${channel_ids}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "getChannelList API");
  }
};


export const saveMatchingRule = async (payload:any) => {
  try {
    const response = await fetch(`${getApiPath.saveMatchingRules}`, {
        method: "POST",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
        body: JSON.stringify(payload),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "saveMatchingRule API");
  }
};


export const getSaveMatchingRule = async (page:Number,page_size:Number,match_status:Number) => {
  try {
    const response = await fetch(`${getApiPath.saveMatchingRules}?page=${page}&page_size=${page_size}&status=${match_status}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "saveMatchingRule API");
  }
};

export const deleteMatchingRule = async (delete_id:number) => {
  try {
    const response = await fetch(`${getApiPath.saveMatchingRules}${delete_id}`, {
        method: "DELETE",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "deleteMatchingRule API");
  }
};

export const updateMatchingRule = async (payload:any,id:number) => {
  try {
    const response = await fetch(`${getApiPath.saveMatchingRules}${id}`, {
        method: "PUT",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
        body: JSON.stringify(payload),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "saveMatchingRule API");
  }
};


export const getChannelNetworkList = async () => {
  try {
    const response = await fetch(`${getApiPath.getChannelNetworkList}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "getChannelNetworkList API");
  }
};